import { Skeleton } from '@/shared/components/ui/skeleton';

/**
 * Pending placeholder for the project-detail route. Mirrors the compact
 * Organizations-style header + content block in `ProjectDetail`.
 */
export function ProjectDetailSkeleton() {
  return (
    <div className="flex flex-1 flex-col gap-3">
      <div className="flex items-center justify-between gap-3">
        <div className="space-y-1">
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-4 w-36" />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="size-7 rounded-full" />
          <Skeleton className="h-7 w-20 rounded-md" />
          <Skeleton className="h-7 w-16 rounded-md" />
        </div>
      </div>
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <Skeleton className="h-7 w-40 rounded-md" />
          <Skeleton className="h-7 w-28 rounded-md" />
        </div>
        <Skeleton className="h-3 w-16" />
      </div>
      <Skeleton className="h-64 w-full rounded-md" />
    </div>
  );
}
